const types = {
  SET_LIST: 'SET_LIST',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/settings/alert-rules/mutations-types.js